// Web Audio API를 활용한 무의존성 사찰 사운드 엔진
class TempleSoundEngine {
  constructor() {
    this.ctx = null;
    this.windChimeInterval = null;
    this.isBgmPlaying = false;
  }

  init() {
    if (!this.ctx) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (AudioContext) {
        this.ctx = new AudioContext();
      }
    }
    if (this.ctx && this.ctx.state === "suspended") {
      this.ctx.resume();
    }
  }

  // 목탁 소리 (Moktak sound synthesis)
  playMoktak() {
    try {
      this.init();
      if (!this.ctx) return;

      const t = this.ctx.currentTime;

      // 주 공명음 (우드블록 / 목탁의 울림)
      const osc = this.ctx.createOscillator();
      const gain = this.ctx.createGain();

      osc.type = "sine";
      osc.frequency.setValueAtTime(780, t);
      osc.frequency.exponentialRampToValueAtTime(320, t + 0.12);

      gain.gain.setValueAtTime(0.8, t);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.14);

      // 타격감 (어택 노이즈 펄스)
      const clickOsc = this.ctx.createOscillator();
      const clickGain = this.ctx.createGain();
      clickOsc.type = "triangle";
      clickOsc.frequency.setValueAtTime(1400, t);
      clickOsc.frequency.exponentialRampToValueAtTime(180, t + 0.03);

      clickGain.gain.setValueAtTime(0.6, t);
      clickGain.gain.exponentialRampToValueAtTime(0.001, t + 0.035);

      osc.connect(gain);
      gain.connect(this.ctx.destination);

      clickOsc.connect(clickGain);
      clickGain.connect(this.ctx.destination);

      osc.start(t);
      clickOsc.start(t);
      osc.stop(t + 0.15);
      clickOsc.stop(t + 0.04);
    } catch (e) {
      console.warn("Moktak sound error:", e);
    }
  }

  // 은은한 사찰 종/풍경 소리 (Temple Wind Chime / Bell)
  playBell(freq = 1046.5) { // C6
    try {
      this.init();
      if (!this.ctx) return;

      const t = this.ctx.currentTime;
      const partials = [1, 2.02, 3.01, 4.2];
      const gains = [0.4, 0.25, 0.15, 0.08];

      partials.forEach((mult, i) => {
        const osc = this.ctx.createOscillator();
        const gain = this.ctx.createGain();

        osc.type = "sine";
        osc.frequency.setValueAtTime(freq * mult, t);

        const decay = 2.5 / (i + 1);
        gain.gain.setValueAtTime(gains[i] * 0.5, t);
        gain.gain.exponentialRampToValueAtTime(0.0001, t + decay);

        osc.connect(gain);
        gain.connect(this.ctx.destination);

        osc.start(t);
        osc.stop(t + decay);
      });
    } catch (e) {
      console.warn("Bell sound error:", e);
    }
  }

  // 산사 풍경 BGM 시작 (바람에 흔들리는 풍경소리 앰비언스)
  startWindChimeBgm() {
    this.init();
    if (this.isBgmPlaying) return;
    this.isBgmPlaying = true;

    const notes = [880, 987.77, 1174.66, 1318.51, 1567.98, 1760]; // 맑은 펜타토닉 음계
    this.playBell(notes[Math.floor(Math.random() * notes.length)]);

    this.windChimeInterval = setInterval(() => {
      if (!this.isBgmPlaying) return;
      // 랜덤한 간격과 높낮이로 은은한 풍경소리 연주
      const randomNote = notes[Math.floor(Math.random() * notes.length)];
      this.playBell(randomNote);
    }, 3800 + Math.random() * 2500);
  }

  // 산사 풍경 BGM 정지
  stopWindChimeBgm() {
    this.isBgmPlaying = false;
    if (this.windChimeInterval) {
      clearInterval(this.windChimeInterval);
      this.windChimeInterval = null;
    }
  }

  toggleBgm() {
    if (this.isBgmPlaying) {
      this.stopWindChimeBgm();
      return false;
    } else {
      this.startWindChimeBgm();
      return true;
    }
  }
}

export const templeSound = new TempleSoundEngine();

